/** BCP 47 tag for Intl / toLocaleString when UI language is ru or en */
export function dateLocaleForLanguage(lng: string): string {
  const base = lng.split('-')[0]?.toLowerCase() ?? 'ru';
  return base === 'en' ? 'en-US' : 'ru-RU';
}
